import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { isName, isEmail, isPhone, num2Thousand, removeFromStore, addKECode } from '../../utils/fn';
import img from '../../assets/product-placeholder.png';
import { setAlert } from '../../store/alert';
import fetch from '../../utils/fetch';
import _ from 'lodash';
import icons from '../../utils/icons.json';
import constants from '../../utils/constants.json';
import { setCartItems } from '../../store/cartItems';
import mpesaLogo from '../../assets/mpesa.png';

function Checkout() {
	const dispatch = useDispatch();
	const navigate = useNavigate()

	useDocumentTitle('Checkout');

	const { user, loggedIn } = useSelector((state) => state.user);
	const cartItems = useSelector((state) => state.cartItems.data);
	const webSettings = useSelector((state) => state.webSettings.data);

	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);

	const [name, setName] = useState(user.LEDGER_NAME || '');
	const [phone, setPhone] = useState(user.CONTACT_PHONE ? user.CONTACT_PHONE.replace('+', '') : '254');
	const [email, setEmail] = useState(user.EMAIL_ADDRESS || '');
	const [branch, setBranch] = useState(webSettings.locations[0].mainLocation);
	const [location, setLocation] = useState(user.ADDRESS || '');
	const [comments, setComments] = useState('');

	const [mpesaData, setMpesaData] = useState(null);
	const [mpesaResponse, setMpesaResponse] = useState(null);
	const [paying, setPaying] = useState(false);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, []);

	function clearCartItems() {
		removeFromStore(constants.CART_ITEMS);
		dispatch(setCartItems([]));
	}

	function submit(e) {
		e.preventDefault();
		if (loading) {
			dispatch(setAlert({ type: 'error', message: 'Please wait!!' }));
			return;
		}
		let res;

		if ((res = isName(name)) === true) {
			if ((res = isPhone(phone)) === true) {
				if ((res = isEmail(email)) === true) {
					if (location.length > 3) {
						setPhone(addKECode(phone));
						setLoading(true);
						dispatch(setAlert('Placing order. Please wait'));
						let cart_items = [];
						cartItems.forEach((item, index) => {
							let obj = {};
							obj.suom = item.suom;
							obj.item_code = item.item_code;
							obj.item_price = parseFloat(item.itemPrice);
							obj.item_name = item.item_name;
							obj.quantity = item.quantity;
							obj.amount_value = parseFloat((parseFloat(item.itemPrice) * item.quantity).toFixed(2));
							cart_items.push(obj);
						});
						fetch
							.get('completeOfflineOrder', {
								client_name: name,
								email,
								phone,
								branch,
								pick_location: location,
								ledger_number: loggedIn ? user.LEDGER_NUMBER : 'GUEST',
								comment: comments,
								cart_items: JSON.stringify(cart_items),
							})
							.then((res) => {
								clearCartItems();
								setResponse(res.list[0]);
								setLoading(false);
								dispatch(setAlert('Done placing order'));
							})
							.catch((err) => {
								setLoading(false);
								dispatch(setAlert({ type: 'error', message: 'Error checking out. ' + err.message }));
							});
						return;
					} else {
						res = 'Pick up location is required or too short';
					}
				}
			}
		}
		dispatch(setAlert({ type: 'error', message: res }));
	}

	function lipaNaMpesa() {
		setPaying(true);
		fetch
			.post('pay-goods-online', mpesaData)
			.then((res) => {
				if ('object' === typeof res) {
					if (res.error === false) {
						res.message = 'Request accepted for processing. Please check your phone.';
					}
					setMpesaResponse(res);
				} else {
					setMpesaResponse({ error: true, message: 'Unknown error occurred performing operation.' });
				}
				setPaying(false);
			})
			.catch((err) => {
				setMpesaResponse({ error: true, message: 'object' === typeof err ? err.message : err });
				setPaying(false);
			});
	}

	function payCheckout() {
		setMpesaData({
			name: name,
			order_no: response.ORDER_NUMBER.toString(),
			order_type: response.ORDER_TYPE.toString(),
			amount: response.AMOUNT.toString(),
			phone_number: phone.toString(),
		});
		setResponse(null);
		//dispatch(setAlert({ type: 'warning', message: 'This function is disabled for now' }));
	}

	function checkoutDone() {
		clearCartItems();
		navigate('/products-and-services');
	}

	return (
		<>
			<div className='main-body checkout-body'>
				{cartItems.length == 0 && (
					<div className='sections' style={{ width: '100%' }}>
						<section className='title'>
							<h3>Checkout</h3>
						</section>
						<p className='pd'>There are not items in your shopping cart for now.</p>
					</div>
				)}
				{cartItems.length > 0 && (
					<>
						<div className='sections sec items'>
							<section className='title'>
								<h3>Products Summary</h3>
								<div className='body'></div>
							</section>
							<table>
								<thead>
									<tr>
										<th>Product</th>
										<th className='col-2'>Name</th>
										<th>Quantity</th>
										<th>Total ({webSettings.CURRENCY})</th>
									</tr>
								</thead>
								<tbody>
									{cartItems.map((item, index) => {
										const productprice = item?.promotion_price > 0 ? item.promotion_price : item.price
										return (
											<tr key={item.item_code}>
												<td>
													<section className='icon' style={{ backgroundImage: `url(${item.src[0] || img})` }}></section>
												</td>
												<td>{item.item_name}</td>
												<td>{item.quantity}</td>
												<td>{num2Thousand((parseFloat(productprice) * item.quantity).toFixed(2))}</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
						<div className='sections sec details'>
							<section className='title'>
								<h3>Delivery Details</h3>
							</section>
							<form onSubmit={submit} autoComplete='off' className='form'>
								<label className='label' htmlFor='name'>
									Your Full Name *
								</label>
								<input onInput={(e) => setName(e.target.value)} className='input' type='text' id='name' value={name} />
								<label className='label' htmlFor='phone'>
									Phone Number * <span style={{ fontWeight: 'normal' }}>(will be used when paying with M-pesa)</span>
								</label>
								<input onInput={(e) => setPhone(e.target.value.trim())} className='input' type='text' id='phone' value={phone} />
								<label className='label' htmlFor='email'>
									Email Address *
								</label>
								<input onInput={(e) => setEmail(e.target.value.trim())} className='input' type='text' id='email' value={email} />
								<label className='label' htmlFor='branch'>
									Preferred Branch *
								</label>
								<select
									onChange={(e) => {
										setBranch(e.target.value);
										//setLocation();
									}}
									value={branch}
									className='input'
									id='branch'>
									{webSettings.locations.map((location, index) => (
										<option key={location.mainLocation + index} value={location.mainLocation}>
											{_.startCase(_.lowerCase(location.locationName))}
										</option>
									))}
								</select>
								<label className='label' htmlFor='location'>
									Pickup Location *
								</label>
								<input onInput={(e) => setLocation(e.target.value)} className='input' type='text' id='location' value={location} />
								<label className='label' htmlFor='comments'>
									Additional information
								</label>
								<textarea onInput={(e) => setComments(e.target.value)} className='input' id='comment' value={comments}></textarea>
								<p className='info'>
									<b>NOTE:</b> Prices are exclusive of delivery fee.
								</p>
								<p className='info'>
									By clicking <b>Place Order</b>, you agree that you want to buy the selected products and that the delivery information you provided are correct
								</p>
								<button className='btn' type='submit' dangerouslySetInnerHTML={{ __html: loading ? 'Placing order...' : 'Place Order' }}></button>
								<span>OR</span>
								<Link className='btn flex' to='/products-and-services'>
									Continue Shopping
								</Link>
							</form>
						</div>
					</>
				)}
			</div>
			{!loading && response && (
				<div className='top-window checkout-window'>
					<div className='inner-window'>
						<span className='icon' dangerouslySetInnerHTML={{ __html: icons.check_circle }}></span>
						<h2>SUCCESS</h2>
						<p>Your order was successfully placed</p>
						<h4>REFERENCE NO: {response.ORDER_NUMBER}</h4>
						<p style={{ marginTop: '10px' }}>
							Item Types: <b>{response.ORDER_COUNT}</b>
						</p>
						<p style={{ marginTop: '10px' }}>
							Order Quantity: <b>{response.ORDER_QUANTITY}</b>
						</p>
						<p style={{ marginTop: '10px', textDecoration: 'underline', fontSize: '90%' }}>
							AMOUNT:{' '}
							<b>
								{webSettings.CURRENCY} {num2Thousand(response.AMOUNT)}
							</b>
						</p>
						<button onClick={payCheckout} type='button' className='btn success'>
							Pay now via M-Pesa
						</button>
						<button onClick={checkoutDone} type='button' className='btn'>
							Done !!
						</button>
					</div>
				</div>
			)}
			{mpesaData && (
				<div className='top-window checkout-window'>
					<div className='inner-window'>
						<div style={{ width: '100%', borderBottom: '1px solid var(--lineColor)', paddingBottom: '20px' }}>
							<img src={mpesaLogo} style={{ height: '40px' }} />
						</div>
						<ul style={{ width: '100%', textAlign: 'start', paddingTop: '20px', display: 'block', listStylePosition: 'inside' }}>
							<li className='sp-bottom'>
								<b>
									{webSettings.CURRENCY} {num2Thousand(mpesaData.amount)}
								</b>{' '}
								will be deducted from your M-pesa. Account no <b>{mpesaData.phone_number}</b>.
							</li>
							<li className='sp-bottom'>Please ensure you have enough balance on your M-pesa account before you proceed.</li>
							<li className='sp-bottom'>Your payments will be recorded once the transaction has been completed.</li>
							<li>Ensure you have your phone with you as you will be prompted to enter your M-pesa PIN.</li>
						</ul>
						{!paying && mpesaResponse && mpesaResponse.error == true && (
							<p style={{ borderLeft: '5px solid var(--errorColor)', width: '100%', padding: '0 10px', color: 'var(--errorColor)', marginTop: '10px', textAlign: 'start' }}>
								Error! {mpesaResponse.message}
							</p>
						)}
						{!paying && mpesaResponse && mpesaResponse.error == false && (
							<>
								<p style={{ borderLeft: '5px solid var(--successColor)', width: '100%', padding: '0 10px', color: 'var(--successColor)', marginTop: '10px', textAlign: 'start' }}>
									Success! {mpesaResponse.message}
								</p>
								<Link className='btn flex' to='/products-and-services' style={{ justifyContent: 'center' }}>
									Back to Products
								</Link>
							</>
						)}
						{!paying && (!mpesaResponse || mpesaResponse.error == true) && (
							<>
								<button type='button' className='btn success' onClick={lipaNaMpesa}>
									Lipa na Mpesa
								</button>
								<button onClick={checkoutDone} type='button' className='btn'>
									Not now
								</button>
							</>
						)}
						{paying && <div dangerouslySetInnerHTML={{ __html: icons.spinner }}></div>}
					</div>
				</div>
			)}
		</>
	);
}

export default Checkout;
